"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.navLink = exports.Nav = void 0;
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var navLink = "hov-bg-primary3 mx1 px3 py1 rnd td-no trn trn2";
exports.navLink = navLink;
var Nav = function (_a) {
    var children = _a.children, logo = _a.logo, name = _a.name;
    return (react_1.default.createElement("nav", { className: "Nav bg-primary4 light1 px5 py1" },
        react_1.default.createElement(react_router_dom_1.NavLink, { className: "".concat(navLink, " d-f hp70 mr3"), to: "/" },
            react_1.default.createElement("img", { className: "ani4 hov-ani-rot h3", src: logo }),
            name === undefined ? undefined : (react_1.default.createElement("p", { className: "as-center f3 ml2" }, name))),
        react_1.default.createElement("div", { className: "d-f f2" }, children)));
};
exports.Nav = Nav;
